/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
import ThemeContext from '@weave-design/theme-context';
import * as React from 'react';
import { WeaveThemeConsumer, WeaveThemeContext } from './WeaveContext';
import { WeaveTheme, weaveThemes } from '../weave.types';
import useLocalStorage from '@innovyze/stylovyze/lib/hooks/useLocalStorage';
/**
 * WeaveProvider is a component that provides the theming context for the Weave Design System
 * @param children
 * @param hasWeaveTheme - If true, the WeaveProvider will provide the theming context for the Weave Design System
 */
export default function WeaveProvider({ children, hasWeaveTheme = false, }) {
    const [theme, setTheme] = useLocalStorage('theme', WeaveTheme.Light);
    const [weaveThemeConsumer, setWeaveThemeConsumer] = React.useState({
        resolvedRoles: {},
        metadata: {},
    });
    const [isWeaveActive, setIsWeaveActive] = useLocalStorage('isWeaveActive', false);
    const themeContextValue = React.useMemo(() => ({ theme, setTheme, isWeaveActive, setIsWeaveActive }), [theme]);
    if (!hasWeaveTheme)
        return React.createElement(React.Fragment, null, children);
    return (React.createElement(ThemeContext.Provider, { value: weaveThemes[theme] },
        React.createElement(WeaveThemeConsumer.Provider, { value: {
                weaveThemeConsumer,
                setWeaveThemeConsumer,
                isWeaveActive,
                setIsWeaveActive,
            } },
            React.createElement(ThemeContext.Consumer, null, ({ resolvedRoles, metadata }) => (React.createElement(React.Fragment, null,
                React.createElement(UseEffect, { effect: () => {
                        setWeaveThemeConsumer({
                            resolvedRoles,
                            metadata,
                        });
                    }, deps: [
                        JSON.stringify(resolvedRoles),
                        JSON.stringify(metadata),
                    ] }),
                React.createElement(WeaveThemeContext.Provider, { value: themeContextValue },
                    React.createElement(React.Fragment, null, children))))))));
}
function UseEffect({ effect, deps }) {
    React.useEffect(effect, deps || []);
    return null;
}
